import React, {useState} from 'react';
import {Avatar, Tooltip} from 'antd';
import {AiOutlineUser} from "react-icons/ai";

import classes from './ScheduleGridItem.module.scss';

import {lessonMightBeHighlightedForDate, reduceGroupsBySpecialityCode} from '../../../../services/scheduleService';
import {formatFioWithInitials} from '../../../../services/generalService';

import DynamicFilledButton from '../../../UI/DynamicFilledButton/DynamicFilledButton';
import {useSelector} from "react-redux";

const ScheduleGridItem = ({ lesson, scheduleItemType, scheduleType, dayName, ifMobileGrid,
                              lessonPeriodIsCurrent, shouldGrayOut }) => {
    const [weekDays] = useState(['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']);

    const currentWeek = useSelector(state => state.schedule.currentWeekNumber);

    const setLessonContainerStyles = () => {
        let containerClass = 'ScheduleGridItem_container_color'
        if (ifMobileGrid) containerClass = containerClass + ` ${classes.mobileContainer}`
        else containerClass = containerClass + ` ${classes.container}`
        const currentDay = new Date().getDay()
        if (dayName === weekDays[currentDay] &&
            lessonMightBeHighlightedForDate(lesson) &&
            lesson.weekNumber.includes(currentWeek) &&
            lessonPeriodIsCurrent) {
            containerClass = containerClass + ` ${classes.currentLesson}`
        }
        let opacityValue = 1
        let maxWidth = 'unset'
        if (scheduleItemType === 'lesson' || scheduleItemType === 'examLesson') {
            if (shouldGrayOut) opacityValue = 0.5
        } else {
            maxWidth = '260px'
        }

        return [containerClass, { opacity: opacityValue, maxWidth: maxWidth }]
    }

    const setLessonType = () => {
        let itemClass = ''

        const lessonType = lesson.lessonTypeAbbrev;
        if (['ЛК', 'УЛк'].includes(lessonType)) itemClass = classes.markAsLecture;
        if (['ПЗ', 'УПз'].includes(lessonType)) itemClass = classes.markAsSeminar;
        if (['ЛР', 'УЛР'].includes(lessonType)) itemClass = classes.markAsLabWork;
        if (lessonType === 'Консультация') itemClass = classes.markAsConsultation;
        if (['Экзамен', 'Канд. экзамен'].includes(lessonType)) itemClass = classes.markAsExam;
        if (['Канд. зачет', 'Дифф. зачет', 'Канд. дифф. зачет', 'Зачет'].includes(lessonType)) itemClass = classes.markAsOffset;

        return itemClass;
    }

    const setGroupsLink = (group, index) => {
        const content = <DynamicFilledButton
            text={group.name}
            href={(group.name.indexOf('-') === -1) ? `/schedule/${group.name}` : `/schedule/${group.name.substr(0, group.name.indexOf('-'))}`}
            onClick={() => { localStorage.setItem('scheduleUrlId', JSON.stringify(group.name.substr(0, group.name.indexOf('-')))) }} />

        return <React.Fragment key={`groupWrapper${index}`}>
            <span key={`groupTooltip${index}`} className={classes.desktopLink}>
                <Tooltip placement="top" title={group.specialityCode + ' ' + group.specialityName + ' (' + group.numberOfStudents + ' студентов)'}>
                    <span style={{ display: 'inline-block' }}>{content}</span>
                </Tooltip>
            </span>
            <span key={`group${index}`} className={classes.mobileLink}>
                {content}
            </span>
        </React.Fragment>
    }

    const setEmployeeLink = (employee, index) => {
        const degreeAndRank = ` 
        ${(employee.degreeAbbrev || employee.rank) ? '(' : ''}${employee.degreeAbbrev ?? ''}${(employee.degreeAbbrev && employee.rank) ? ', ' : ''}${employee.rank ?? ''}${(employee.degreeAbbrev || employee.rank) ? ')' : ''}`

        const content = <DynamicFilledButton
            text={formatFioWithInitials(employee)}
            href={`/schedule/${employee.urlId}`}
            onClick={() => { localStorage.setItem('scheduleUrlId', JSON.stringify(employee.urlId)) }}
            styles={{ width: 'fit-content', padding: '0 10px', textAlign: 'left' }} />

        return <React.Fragment key={`employeeWrapper${index}`}>
            <span key={`employeeTooltip${index}`} className={classes.desktopLink}>
                <Tooltip
                    placement="top"
                    title={<React.Fragment>
                        <div className={classes.avatarContainer}>
                            <Avatar
                                size={90}
                                src={employee.photoLink}
                                icon={<AiOutlineUser style={{ position: 'relative', top: '-5px' }} />} />
                        </div>
                        <div style={{ textAlign: 'center' }}>{[employee.lastName, employee.firstName, employee.middleName].filter(Boolean).join(" ")}</div>
                        <div style={{ textAlign: 'center' }}>{degreeAndRank}</div>
                    </React.Fragment>}>
                    <span style={{ display: 'inline-block' }}>{content}</span>
                </Tooltip>
            </span>
            <span key={`employee${index}`} className={classes.mobileLink}>
                {content}
            </span>
        </React.Fragment>
    }

    return (
        <div className={setLessonContainerStyles()[0]}
            style={setLessonContainerStyles()[1]}>

            <div className={setLessonType()}/>

            <div className={classes.subjectDetails}>
                <div>
                    <span>
                        {lesson.subjectFullName
                            ? <Tooltip
                                overlayStyle={{ maxWidth: '200px' }}
                                placement="topLeft"
                                title={lesson.subjectFullName}>
                                <b style={{ cursor: 'help' }}>{lesson.subject}</b>
                            </Tooltip>
                            : <b>{lesson.subject}</b>}
                        {' (' + lesson.lessonTypeAbbrev + ')'}
                    </span>
                    <span>
                        {lesson.auditories.map((el, index) => <span key={index}>{el}</span>)}
                    </span>
                </div>

                {(scheduleItemType === 'exam' || scheduleItemType === 'examLesson' || ifMobileGrid) && <React.Fragment>
                    <div className={`${classes.dateLesson} ScheduleGridItem_details_color`}>
                        {scheduleItemType === 'examLesson' ? <span>{`Дата: `}<span
                            className={`${classes.bold}`}>{`${lesson.dateLesson}`}</span></span> : ""}
                    </div>
                    <div className={`${classes.time} ScheduleGridItem_details_color`}>
                        <span>{`Время: `}<span
                            className={`${classes.bold}`}>{`${lesson.startLessonTime} - ${lesson.endLessonTime}`}</span></span>
                    </div>
                </React.Fragment>}

                {(scheduleItemType === 'lesson') &&
                    <div className={`${classes.weekNumbers} ScheduleGridItem_details_color`}>
                        {lesson.weekNumber.length !== 4 && <span>
                            <span>Недели:&nbsp;</span>
                            {lesson.weekNumber.map((el, index) => <span key={index}><b>{(index !== lesson.weekNumber.length - 1) ? (el + ', ') : el}</b></span>)}
                            &nbsp;
                        </span>}
                        <span className={classes.studyPeriod}>
                            {lesson.startLessonDate === lesson.endLessonDate ? `(только ${lesson.startLessonDate.substring(0, 5)})` : `(с ${lesson.startLessonDate.substring(0, 5)} по ${lesson.endLessonDate.substring(0, 5)})`}
                        </span>
                    </div>}

                <div>
                    <span>
                        {(scheduleType === 2) && reduceGroupsBySpecialityCode(lesson.studentGroups).map((group, index) => setGroupsLink(group, index))}
                        {(scheduleType === 1) && lesson.employees?.map((employee, index) => setEmployeeLink(employee, index))}
                    </span>

                    {(lesson.numSubgroup !== 0) &&
                    <span
                        className={classes.subgroupLabel}>
                        {lesson.numSubgroup + ' п.'}</span>}
                </div>

                <div className={classes.note}>{lesson.note}</div>
            </div>
        </div>)
};

export default ScheduleGridItem;
